"use strict";

(() => {
    document.addEventListener('DOMContentLoaded', () => {
        initSwiper();
        lightbox.init();
        changeLooxAppearance();
        reviewBar();
        openReviews();
    });
	
    /******************************************************************/
    /* swiper
    /******************************************************************/

    const initSwiper = () => {
        const gallery = document.querySelector('.image-gallery__swiper');
        const lengthOfSwiperThumb = document.querySelectorAll('.image-gallery-thumb__swiper').length;
        let pdpThumbnailSwiper;
 
        if(lengthOfSwiperThumb === 1) {
            const thumbnail = document.querySelector('.image-gallery-thumb__swiper');

            pdpThumbnailSwiper = new Swiper(thumbnail, {
                loop: true,
                autoHeight: true,
                spaceBetween: 15,
                slidesPerView: 5
            });    
        }

        const pdpViewSwiper = new Swiper(gallery, {
            spaceBetween: 10,
            grabCursor: true,
            slidesPerView: 1,
            autoHeight: true,
            watchSlidesProgress: true,
            thumbs: {
                swiper: lengthOfSwiperThumb < 1 ? null : pdpThumbnailSwiper ,
            },
            navigation: {
                prevEl: document?.querySelector('.image-gallery__swiper-wrapper .swiper-button-prev'),
                nextEl: document?.querySelector('.image-gallery__swiper-wrapper .swiper-button-next'),
            }
        });

        pdpViewSwiper.on("slideChange", (item) => {
            const videos = document.querySelectorAll(".image-gallery__swiper video");
        
            // pause all videos
            videos.forEach((video) => {
                video.pause();
            });
        
            // play video if currentslide has video
            let currentSlide = pdpViewSwiper.slides[pdpViewSwiper.activeIndex];
            let currentSlideVideo = currentSlide.querySelector("video");
    
            if (currentSlideVideo) {
              currentSlideVideo.play();
            }
        });
    }

    /******************************************************************/
    /* photoswipe lightbox
    /******************************************************************/

    const lightbox = new PhotoSwipeLightbox({
        gallery: '.image-gallery',
        children: 'a',
        pswpModule: PhotoSwipe 
    });

    /******************************************************************/
    /* loox appearance
    /******************************************************************/

    const changeLooxAppearance = () => {
        setTimeout(() => {
            const looxRatings = document.querySelectorAll('.product-meta .loox-rating, .review-bar .loox-rating');
            let ratingText;
    
            // product meta
            looxRatings.forEach((looxRating)=> {
                if(looxRating.querySelector('.loox-rating-content')) {
                    let numberOfRates = parseInt(looxRating.dataset.raters);
                    const looxRatingContent = looxRating.querySelector('.loox-rating-content');
                    ratingText = numberOfRates <= 1 ? `${numberOfRates} Bewertung` : `${numberOfRates} Bewertungen`;
    
                    looxRatingContent.insertAdjacentHTML('afterend', `<div class="loox-rating-total">${ratingText}</div>`)
                }
            })
        },300);
    }

    /******************************************************************/
    /* review-bar
    /******************************************************************/

    const reviewBar = () => {
        const reviewBars = document.querySelectorAll('.review-bar');
        const reviewBlock = document.querySelector(".product-block-list__item--reviews");
        const looxRating = parseFloat(document.querySelector('.review-bar .loox-rating').dataset.rating);

        // do only if product was rated by looxRating
        if(looxRating) {
            const targetAverage = looxRating;
            const minRange = 3.0;
            const maxRange = 5.0;

            //show section
            reviewBars.forEach((reviewBar) => {
                reviewBar.classList.add('visible');
                reviewBlock && reviewBlock.classList.add('visible');
            })
    
            const getRandomFloat = (min, max) => {
                return Math.random() * (max - min) + min;
            }
    
            const generateThreeRandomValues = (targetAverage, min, max) => {
                let minValue = targetAverage >= 4.0 ? 4.0 : min ;

                if (targetAverage === max) {
                    return {
                        scoreValue1: {
                            value: max,
                            percentValue: 100
                        },
                        scoreValue2: {
                            value: max,
                            percentValue: 100
                        },
                        scoreValue3: {
                            value: max,
                            percentValue: 100
                        }
                    };
                } else if (targetAverage === minValue) {
                    return {
                        scoreValue1: {
                            value: min.toFixed(2),
                            percentValue: minValue * 100 / max
                        },
                        scoreValue2: {
                            value: min.toFixed(2),
                            percentValue: minValue * 100 / max
                        },
                        scoreValue3: {
                            value: min.toFixed(2),
                            percentValue: minValue * 100 / max
                        }
                    };
                }
    
                let attempts = 0;
                const maxAttempts = 100;
                let value1, value2, value3;
                let percentValue1, percentValue2, percentValue3;
    
                while (attempts < maxAttempts) {
                    attempts++;
    
                    value1 = getRandomFloat(minValue, max);
                    value2 = getRandomFloat(minValue, max);
                    value3 = targetAverage * 3 - value1 - value2;

                    percentValue1 = value1 * 100 / max;
                    percentValue2 = value2 * 100 / max;
                    percentValue3 = value3 * 100 / max;
    
                    if (value3 >= minValue && value3 <= max) {
                        break;
                    }
                }

                return {
                    scoreValue1: {
                        value: value1,
                        percentValue: percentValue1
                    },
                    scoreValue2: {
                        value: value2,
                        percentValue: percentValue2
                    },
                    scoreValue3: {
                        value: value3,
                        percentValue: percentValue3
                    }
                };
            };
    
            const saveRandomValuesToLocalStorage = (productId, randomValues) => {
                const key = `product_${productId}`;
                localStorage.setItem(key, JSON.stringify(randomValues));
            };
    
            const getRandomValuesFromLocalStorage = (productId) => {
                const key = `product_${productId}`;
                const storedValues = localStorage.getItem(key);
              
                return storedValues ? JSON.parse(storedValues) : null;
            };

            const fillValueAndProgessbar = (objOfValues) => {
                reviewBars.forEach((reviewBar) => {
                    const tasteSelector = reviewBar.querySelector('.review-bar__taste span');
                    const packagingSelector = reviewBar.querySelector('.review-bar__packaging span');
                    const raritySelector = reviewBar.querySelector('.review-bar__rarity span');
            
                    const tasteBar = reviewBar.querySelector('.review-bar__taste .review-bar__progress-bar');
                    const packagingBar = reviewBar.querySelector('.review-bar__packaging .review-bar__progress-bar');
                    const rarityBar = reviewBar.querySelector('.review-bar__rarity .review-bar__progress-bar');
            
                    // set value
                    tasteSelector.innerHTML = parseFloat(objOfValues.scoreValue1.value).toFixed(2);
                    packagingSelector.innerHTML = parseFloat(objOfValues.scoreValue2.value).toFixed(2);
                    raritySelector.innerHTML = parseFloat(objOfValues.scoreValue3.value).toFixed(2);

                    // set percentage value
                    tasteBar.style.width = objOfValues.scoreValue1.percentValue + '%';
                    packagingBar.style.width = objOfValues.scoreValue2.percentValue + '%';
                    rarityBar.style.width = objOfValues.scoreValue3.percentValue + '%';
                })
            }
    
            const retrievedValues = getRandomValuesFromLocalStorage(productID);
    
            if (!retrievedValues) {
                // if randomValues are not in local Storage, generate and save
                const randomValues = generateThreeRandomValues(targetAverage, minRange, maxRange);
                saveRandomValuesToLocalStorage(productID, randomValues);
                // console.log('generate values: ' + randomValues);
                fillValueAndProgessbar(randomValues)
            } else {
                // console.log(retrievedValues)
                fillValueAndProgessbar(retrievedValues)
            }
        }
    }

    /******************************************************************/
    /* open reviews
    /******************************************************************/

    const getOffsetTop = (element) => {
        let offsetTop = 0;
        while(element) {
          offsetTop += element.offsetTop;
          element = element.offsetParent;
        }
        return offsetTop;
    }

    const openReviews = () => {
        const looxLinks = document.querySelectorAll(".product-block-list .looxReviews");

        looxLinks.forEach((looxLink) => {
            looxLink.addEventListener("click", () => {
                const reviewsCollapsibleButton = document.querySelector(".product-block-list__item--reviews .card__collapsible-button");
                const reviewsCollapsibleButtonClosed = document.querySelector(".product-block-list__item--reviews .card__collapsible-button[aria-expanded=false]");
                const offsetTop = getOffsetTop(reviewsCollapsibleButton);
                const headerHeight = document.querySelector(".shopify-section__header").offsetHeight;
                const headerOffset = headerHeight + 10;

                if (reviewsCollapsibleButton) {
                    // open only if is closed
                    if(reviewsCollapsibleButtonClosed !== null) {
                        reviewsCollapsibleButton.click();
                    }

                    window.scrollTo({ 
                        top: offsetTop - headerOffset,
                        behavior: "smooth" 
                    });
                }
            })
        })
    }
})();
